/**
 * @fileoverview ReportviewComponent - 報表檢視元件
 * @description
 * 此元件提供報表檢視功能，支援在線預覽、下載和郵件發送功能。
 * 基於 jkQueryComponent 實現，提供報表列表和內容預覽功能。
 *
 * @author JK Team
 * @version 1.0.0
 */
import { JkeditComponent, JktextComponent, MaterialModule, TitlebarComponent } from 'jk-service';
import {
  idNameItem,
  jkLib,
} from 'jk-service';
import { Component, Injector, NgModule, OnInit, inject, input, viewChild } from '@angular/core';
import { JkBaseOption } from 'jk-service';
import {
  JkdownloadFileComponent,
} from 'jk-service';
import { RowClickedEvent, RowDoubleClickedEvent } from 'ag-grid-community';
import { SafePipe } from 'safe-pipe';
import { ReportService } from 'jk-service';
import { JobMailOption } from 'jk-service';
import { jkQueryComponent } from '../jkQuery';
import { JkgridwinComponent } from '../jkgridwin/jkgridwin.component';



/**
 * @class FilterOption
 * @description 過濾選項類別，繼承自 JkBaseOption
 * @extends {JkBaseOption}
 */
class FilterOption extends JkBaseOption {
  // ###
}

/**
 * @component ReportviewComponent
 * @description
 * 報表檢視元件，提供報表列表顯示和內容預覽功能。
 * 支援報表在線預覽、下載和郵件發送。
 * 基於 jkQueryComponent 實現，使用 iframe 預覽報表內容。
 * @extends {jkQueryComponent}
 */
@Component({
  standalone: true,
  selector: 'app-reportview',
  templateUrl: './reportview.component.html',
  styleUrls: [],
  imports: [MaterialModule, SafePipe, JkeditComponent, TitlebarComponent, JkgridwinComponent, JkdownloadFileComponent, JktextComponent],
})
export class ReportviewComponent extends jkQueryComponent implements OnInit {
  reportSrv = inject(ReportService);

  override _programId = 'reportview'; // ###
  readonly downloadFile = viewChild.required<JkdownloadFileComponent>('jkdownload');
  pageOpt: JobMailOption = new JobMailOption(this.programId + '_page'); //###
  //filterOpt: FilterOption = new FilterOption(this.programId);//###
  orderList: idNameItem[] = [];
  date = '';
  readonly reportUrl = input<string>('');
  constructor() {
    super();
    this.onOpenReport.bind(this);
    this.onOpenReport.bind(this);
    this.onDownloadReport.bind(this);
    this.gridInitOpt = {
      pageKind: this.pageKind,
      programId: this.programId,
      sortField: 'KA001',
      sort: 'desc',
      defaultSort: null,
    };

    this.setFormOpt2(); //###
    this.logMessage = '無錯誤訊息';
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    const downloadFile = this.downloadFile();
    if (downloadFile) {
      downloadFile.init('', '', 'application/pdf');
    }

    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
  }
  override afterGridReady($event: JkgridwinComponent) {
    super.afterGridReady($event);
    this.doQuery();
  }

  doSelectRow(e: RowClickedEvent<any, any>) {
    const gridInstance = this.masterGrid;
    if (!gridInstance) return;
    console.log('rowIndex:', e.rowIndex, 'masterGrid.focusedRowIndex:', gridInstance.focusedRowIndex);
    if (gridInstance.focusedRowIndex < 0) {
      return;
    }
    if (e.rowIndex === 0 && gridInstance.focusedRowIndex !== 0) {// 修正異常無法選第一筆
      gridInstance.focusedRowIndex = e.rowIndex;
    };
    //this.urlPath = '';
    //this.fileName = '';
    let item = gridInstance.selectedItem; //this.masterGrid.itemList[this.masterGrid.focusedRowIndex];
    if (item['成功筆數'] === 0) {
      return;
    }
    // 設定 urlPath iFrame 的路徑, 並顯示 iFrame
    this.reportSrv.setReportPath(this.reportUrl(), item['FILENAME']); // jkGlb.env.reportUrl
    return;
  }
  override agRowClicked($event: RowClickedEvent<any, any>) {
    // RowClickedEvent<any, any>
    if ($event.rowIndex === undefined)
      // 過濾掉 不知哪來的事件
      return;
    super.agRowClicked($event);
    this.doSelectRow($event);
  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    this.type = 'S';
    this.winItem = 'S01';
    this.mainTable = 'SYSKA';
    this.where =
      ' AND KA003= ' +
      jkLib.quotedStr(this.reportSrv.dbname) +
      ' AND KA015=' +
      jkLib.quotedStr(this.uid);

    this.order = ' ORDER BY KA001 DESC, KA002 DESC ';
    return true;
  }
  override onAfterQuery(item: any, ret: any) {
    super.onAfterQuery(item, ret);
    if (item) this.reportSrv.setReportPath(this.reportUrl(), item['FILENAME']);
  }
  onDownloadReport(): Promise<boolean> {
    const gridInstance = this.masterGrid;
    if (!gridInstance) return Promise.resolve(false);
    return this.reportSrv.downloadReport(this.reportUrl(), gridInstance.focusedRowIndex, gridInstance.itemList);
  }
  async onOpenReport(): Promise<boolean> {
    const gridInstance = this.masterGrid;
    if (!gridInstance) return Promise.resolve(false);
    this.reportSrv.openReport(this.reportUrl(), gridInstance.focusedRowIndex, gridInstance.itemList);
    this.masterTabGroupIndex = 2;
    return true;
  }

  override agRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    super.agRowDoubleClicked($event);
    this.onOpenReport();
  }
  doMail() {
    this.reportSrv.mail(this.pageOpt, this.ret);
  }
}
